export default "__VITE_ASSET__D11If3Go__"